import {
  DISABLE_BUTTON,
  ENABLE_BUTTON,
  SET_EMAIL,
  SET_ERROR,
  SET_STEP,
} from "../types";

const initialState = {
  isButtonDisabled: false,
  currentStep: "1",
  error: "",
  email: "",
};

export const forgotPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISABLE_BUTTON:
      return { ...state, isButtonDisabled: true };
    case ENABLE_BUTTON:
      return { ...state, isButtonDisabled: false };
    case SET_STEP:
      return { ...state, currentStep: action.payload };
    case SET_ERROR:
      return { ...state, error: action.payload };
    case SET_EMAIL:
      return { ...state, email: action.payload };
    default:
      return state;
  }
};
